/**
 * Copyright (c) 2026 Constructor Technology AG. All rights reserved.
 *
 * Proprietary and confidential. Unauthorized copying, distribution, or use
 * is prohibited.
 *
 * SPDX-License-Identifier: LicenseRef-Constructor-Proprietary
 */

import router from '../../router'
import Login from './Login.vue'

// Setup routes
export default () => {
  router.addRoutes([
    {
      path: '/login',
      name: 'login',
      components: {
          default: Login,
        }
    }
  ])
}
